<template>
  <div class="aboutus">
    <navigation></navigation>
    <div style="width: 100%; height: 80px"></div>
    <div class="banner">
      <div
        style="width: 1200px; height: 400px; margin: 0 auto; position: relative"
      >
        <p
          style="
            line-height: 57px;
            font-size: 58px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            position: absolute;
            left: 100px;
            top: 132px;
          "
        >
          关于我们
        </p>
        <p
          style="
            line-height: 59px;
            font-size: 73px;
            font-family: Microsoft YaHei;
            font-weight: 300;
            color: #ffffff;
            opacity: 0.5;
            position: absolute;
            left: 100px;
            top: 221px;
          "
        >
          About us
        </p>
      </div>
    </div>
    <div
      style="width: 100%; height: 500px; background: #ffffff"
      class="jianjie"
    >
      <div
        style="
          width: 1200px;
          margin: 0 auto;
          padding-top: 49px;
          box-sizing: border-box;
          display: flex;
          justify-content: space-around;
        "
      >
        <div
          style="
            width: 510px;
            height: 371px;
            position: relative;
          "
        >
          <img
            style="width: 510px; height: 371px"
            src="../../static/aboutus/imgleft.png"
            alt=""
          />
        </div>
        <div style="flex: 1; padding-left: 40px; padding-top: 30px">
          <p
            style="
              line-height: 22px;
              font-size: 24px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #3476c1;
              margin-bottom: 28px;
            "
          >
            公司简介
          </p>
          <p
            style="
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
              line-height: 25px;
              text-indent: 2em;
            "
          >
            启创未来（北京）科技有限公司，在“大众创业、万众创新”新时代的感召下，
            是以“创新发展”与“高端普惠”为战略支撑的综合性创新创业服务性企业；是以“一府一校”为基本业务方向，
            以打造“一云一港”（启创云
            启创港）为目标，提供“服务共享型创新创业云平台”领先的“互联网+创新和创就业教育升级版”综合服务提供商；
            是背负“凝聚公益力量、助力创业梦想”
            的新时代历史使命，实现跨界资源整合、协同创新均衡高效发展、实现“践行升级版双创时代历史使命，打造全新创就业生态链”愿景的行业引领者。
          </p>
          <p
            style="
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
              line-height: 25px;
              text-indent: 2em;
            "
          >
            公司推出东云启创“两平台一服务”教学方案是内蒙古官方指定唯一享受政府补贴的“创业培训”服务云平台，是内蒙古自治区政府推荐参加“首届全国创业就业服务展示交流活动”并荣获“优秀项目奖”的企业；是优才创智股东包括李开复博士的创新工场的战略合作伙伴；与教育部、人社部等相关机构结为战略合作伙伴，与中国欧美留学会、中国职业教育与就业协会形成合作的高新技术企业。
          </p>
        </div>
      </div>
    </div>
    <div
      style="
        width: 100%;
        height: 605px;
        background-color: #f5f5f5;
        padding-top: 77px;
      "
    >
      <p
        style="
          line-height: 23px;
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #3476c1;
          text-align: center;
          margin-bottom: 30px;
        "
      >
        联系我们
      </p>
      <p
        style="
          line-height: 15px;
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 300;
          color: #999999;
          text-align: center;
        "
      >
        CONTACT US
      </p>
      <div
        style="
          width: 1200px;
          margin: 0 auto;
          padding-top: 49px;
          box-sizing: border-box;
          display: flex;
        "
      >
        <div style="padding-left:110px;padding-top:40px">
          <p style="margin-bottom:18px">
            <img
              style="
                width: 25px;
                height: 25px;
                vertical-align: middle;
                margin-right: 20px;
                display:inline-block;
              "
              src="../../static/aboutus/gonsi.png"
              alt=""
            />
            <span
              style="
                line-height: 15px;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #333333;
              "
              >公司名称： 启创未来（北京）科技有限公司</span
            >
          </p>
          <p style="margin-bottom:18px">
            <img
              style="
                width: 25px;
                height: 25px;
                vertical-align: middle;
                margin-right: 20px;
                display:inline-block;
              "
              src="../../static/aboutus/guanwang.png"
              alt=""
            />
            <span
              style="
                line-height: 15px;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #333333;
              "
              >公司官网：  http://www.qcwlcloud.com</span
            >
          </p>
          <p style="margin-bottom:18px">
            <img
              style="
                width: 25px;
                height: 25px;
                vertical-align: middle;
                margin-right: 20px;
                display:inline-block;
              "
              src="../../static/aboutus/dizhi.png"
              alt=""
            />
            <span
              style="
                line-height: 15px;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #333333;
              "
              >公司地址：  北京市海淀区西三旗建材城东路18号佰能大厦</span
            >
          </p>
          <p style="margin-bottom:18px">
            <img
              style="
                width: 25px;
                height: 25px;
                vertical-align: middle;
                margin-right: 20px;
                display:inline-block;
              "
              src="../../static/aboutus/dianhua.png"
              alt=""
            />
            <span
              style="
                line-height: 15px;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #333333;
              "
              >联系电话：  400-1858-365</span
            >
          </p>
          <p style="margin-bottom:18px">
            <img
              style="
                width: 25px;
                height: 25px;
                vertical-align: middle;
                margin-right: 20px;
                display:inline-block;
              "
              src="../../static/aboutus/youxiang.png"
              alt=""
            />
            <span
              style="
                line-height: 15px;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #333333;
              "
              >公司邮箱：  post@qcwlcloud.com</span
            >
          </p>
        </div>
        <div style="flex:1;text-align: right;">
            <img style="width:450px;height:300px;margin-right:80px; display:inline-block;" src="../../static/aboutus/lianxiwomen.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import helloworld from '@/components/helloworld.vue' //引入组件
import navigation from "@/components/common/navigation";

export default {
  name: "aboutus",
  components: {
    navigation,
  },
  data() {
    return {
      data: {},
    };
  },
  methods: {
    toActivity() {
      this.$router.push("/activity");
    },
  },
  created() {},
  mounted() {
    //滚动条从顶部开始
    let osTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (osTop > 0) {
      document.documentElement.scrollTop = document.body.scrollTop = 0;
    }
  },
};
</script>

<style lang="less">
.aboutus {
  width: 100%;
  .banner {
    width: 100%;
    height: 400px;
    background: url(../../static/aboutus/banner.png);
    background-size: 100% 100%;
    background-position: center;
    position: relative;
  }
}
</style>